import { Gender } from 'root-constants'
import { TOptionOf } from 'root-types'

export const WOMAN_MAN_GENDER_OPTIONS = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
  },
] as const satisfies readonly TOptionOf<typeof Gender>[]
